import { Check } from "lucide-react"
import { cn } from "@/lib/utils"

interface Step {
  title: string
  description: string
}

interface ResourceRequestStepperProps {
  steps: Step[]
  currentStep: number
  onStepClick: (step: number) => void
}

export function ResourceRequestStepper({ steps, currentStep, onStepClick }: ResourceRequestStepperProps) {
  return (
    <div className="w-full">
      <ol className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-2">
        {steps.map((step, index) => {
          const isCompleted = index < currentStep
          const isCurrent = index === currentStep

          return (
            <li key={index} className="relative">
              <button
                onClick={() => isCompleted && onStepClick(index)}
                className={cn(
                  "group flex w-full flex-col border-l-4 py-2 pl-4 md:border-l-0 md:border-t-4 md:pb-0 md:pl-0 md:pt-4",
                  isCompleted || isCurrent ? "border-primary" : "border-muted-foreground/20",
                )}
                aria-current={isCurrent ? "step" : undefined}
              >
                <span className="flex items-center gap-2">
                  <span
                    className={cn(
                      "flex h-8 w-8 items-center justify-center rounded-full border-2 text-center font-medium",
                      isCompleted
                        ? "border-primary bg-primary text-primary-foreground"
                        : isCurrent
                          ? "border-primary text-foreground"
                          : "border-muted-foreground/20 text-muted-foreground",
                    )}
                  >
                    {isCompleted ? <Check className="h-4 w-4" /> : <span>{index + 1}</span>}
                  </span>
                  <span className={cn("text-sm font-medium", isCurrent ? "text-foreground" : "text-muted-foreground")}>
                    {step.title}
                  </span>
                </span>
                <span
                  className={cn(
                    "mt-1 hidden text-sm md:block",
                    isCurrent ? "text-muted-foreground" : "text-muted-foreground/60",
                  )}
                >
                  {step.description}
                </span>
              </button>
            </li>
          )
        })}
      </ol>
    </div>
  )
}

